<template>
  <div v-for="(leg, index) in cars.route" :key="index" class="item">
    <div class="line">
      {{ leg.placeCollect.name }}
    </div>
    <div class="line"><span>Pick-up</span>{{ getDateFlightfox(leg.dateCollect) }}</div>
    <div class="line"><span>Drop-off</span>{{ getDateFlightfox(leg.dateReturn) }}</div>
    <div v-if="cars.isReturnDifferentPlace" class="line">
      {{ leg.placeReturn.name }}
    </div>
  </div>
</template>

<script setup>
import DateTime from "../utils/datetime.js";

defineProps(["cars"]);

const { getDateFlightfox } = DateTime();
</script>
